module.exports = __webpack_public_path__ + "static/media/arrow-complete-left.0a60e97b.svg";